import { render, staticRenderFns } from "./VxScrollTrigger.vue?vue&type=template&id=5804186e&scoped=true"
import script from "./VxScrollTrigger.vue?vue&type=script&lang=js"
export * from "./VxScrollTrigger.vue?vue&type=script&lang=js"
import style0 from "./VxScrollTrigger.vue?vue&type=style&index=0&id=5804186e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804186e",
  null
  
)

export default component.exports